var Avatar = require('avatar');
var AvatarUploadPreview = require('./avataruploadpreview.es6').default;
var Formatter = require('formatter');
var Channel = require('channel');
var Connection = require('connection');
var Message = require('message');
var LineMessageRenderer = require('linemessagerenderer');
var OverlayContainerView = require('overlaycontainerview');
var IRCCloudNotifier = require('irccloudnotifier');
var startSlackAuth = require('../lib/slack.es6').startAuth;
var UA = require('../lib/ua.es6');

require('settings.scss');


var SettingsView = Backbone.View.extend({
    el: '.settingsContainer',
    defaultSection: 'design',
    initialize: function (options) {
        this.selected = false;
        
        this.enableNotifications = $('.enableNotifications');
        
        this.avatar = new AvatarUploadPreview({
            session: this.model,
            el: this.$('.avatarPreview')
        }).setModel(this.model);
        this.name = $('#settingsName');
        this.email = $('#settingsEmail');
        this.highlights = $('#settingsHighlights');
        this.autoaway = $('#settingsAutoaway');
        this.closeButton = $('.settingsClose');
        this.error = $('.settingsError');
        
        this.userPrefsCheckboxes = $('.userPrefsCheckbox');
        this.labsCheckboxes = $('.labsCheckbox');
        
        this.messageLayoutPreview = this.$('.messageLayout__preview');
        
        this.accountFormErrors = $('.settingsAccountForm .userError');
        this.accountFormSuccesses = $('.settingsAccountForm .userSuccess');
        this.settingsCurrentPasswords = $('.settingsCurrentPassword');
        
        this.settingsNewPassword = $('#settingsNewPassword');

        this.passwords = this.$('input[type=password]');
        
        this.formatter = new Formatter();
        
        this.model.bind('init', this.init, this);
        this.model.bind('notificationPermissionRequested', this.renderEnableNotifications, this);
        
        this.overlay = new OverlayContainerView({
            model: this.model,
            session: this.model
        });
        
        this.debouncedSave = _.debounce(_.bind(this.save, this), 300);
        
        this.render();
    },
    events: {
        'buttonClick .settingsSubmit': 'submitForm',
        'buttonClick .settingsClose': 'hide',
        'submit .settingsAccountForm__email': 'submitEmailForm',
        'submit .settingsAccountForm__password': 'submitPasswordForm',
        'submit .settingsAccountForm__delete': 'submitDeleteForm',
        'buttonClick .export': 'clickExportLogs',
        'buttonClick .settingsAccountForm .cancel': 'hideAccountForms',
        'buttonClick .enableNotifications__button': 'clickEnableNotifications',
        'buttonClick #testAlertSound': 'testAlertSound',
        'click .sidebarChooser': 'chooseSidebarLayout',
        'click .themeChooser': 'chooseTheme',
        'buttonClick .fontChooser': 'chooseFont'
    },
    isSelected: function () {
        return this.selected;
    },
    show: function (section) {
        this.selected = true;
        this.showSection(section);
        this.$el.addClass('settingsContainer--show');
        this.passwords.prop('disabled', false);
        this.model.trigger('settingsShown');
    },
    showSection: function (section) {
        if (!this.$('.settingsContents__' + section).length) {
            this.model.trigger('navigate', '?/settings', {trigger: true, replace: true});
            return;
        }
        this.reset();
        if (section === 'notifications') {
            this.renderEnableNotifications();
        }
        if (section == 'account') {
            this.$('.settingsAccountSessions_head').addClass('loading');
            this.model.getStreams(_.bind(function (response) {
                if (response.success) {
                    this.$('.settingsAccountSessions_head').removeClass('loading');
                    var table = $('<table>');
                    _.each(_.sortBy(Object.values(response.sessions), 'issue_date'), function (session) {
                        var headRow = $('<tr>');
                        headRow.append($('<th>').text('Login date'));
                        headRow.append($('<th>').text('Expires'));
                        headRow.append($('<th>').text('Login IP'));
                        headRow.append($('<th>').text('Login user agent'));
                        headRow.append($('<th class="settingsAccountSessions_clients">').text('Active clients'));
                        table.append(headRow);
                        var row = $('<tr class="settingsAccountSessions_session">');
                        row.append($('<td class="settingsAccountSessions_date">').text(
                            new Date(session.issue_date * 1000).toString('ddd dd MMM yyyy HH:mm')
                        ));
                        row.append($('<td class="settingsAccountSessions_expiry">').text(
                            new Date((session.issue_date + session.maxage) * 1000).toString('ddd dd MMM yyyy HH:mm')
                        ));
                        row.append($('<td class="settingsAccountSessions_ip">').text(session.ip_address));
                        row.append($('<td class="settingsAccountSessions_ua">').text(session.user_agent).prepend(UA.icons(session.user_agent)));
                        row.append($('<td class="settingsAccountSessions_clients">').text(session.streams.length));
                        table.append(row);
                        if (session.streams.length) {
                            var streamHeadRow = $('<tr>');
                            streamHeadRow.append($('<th colspan="2">').text('Client start'));
                            streamHeadRow.append($('<th>').text('Client IP'));
                            streamHeadRow.append($('<th>').text('Client user agent'));
                            table.append(streamHeadRow);
                            _.each(_.sortBy(session.streams, 'start_time'), function (stream) {
                                var rowClass = 'settingsAccountSessions_stream_row';
                                var self = stream.self || (stream.stream_id == this.model.getStreamId());
                                if (self) {
                                    rowClass += ' settingsAccountSessions_stream_row--self';
                                }

                                var streamRow = $('<tr>').addClass(rowClass);
                                streamRow.append($('<td class="settingsAccountSessions_stream_start">').text(
                                    new Date(stream.start_time * 1000).toString('ddd dd MMM yyyy HH:mm')
                                ));
                                var streamStart = $(this.formatter.howLong(
                                    new Date(stream.start_time * 1000)
                                ));
                                streamRow.append($('<td class="settingsAccountSessions_stream_age">').html(streamStart));
                                streamRow.append($('<td class="settingsAccountSessions_stream_ip">').text(stream.ip_address));
                                streamRow.append($('<td class="settingsAccountSessions_sream_ua">').text(stream.user_agent).prepend(UA.icons(stream.user_agent)));
                                if (self) {
                                    streamRow.append($('<th class="settingsAccountSessions_sream_current">').text('Current'));
                                }
                                table.append(streamRow);
                            }, this);
                        }
                    }, this);
                    if (response.bnc.length) {
                        var bncHead = $('<tr>').append($('<td colspan="4">').append(
                            $('<h3>').text('Bouncer connections')
                        ));
                        table.append(bncHead);
                        var bncHeadRow = $('<tr>');
                        bncHeadRow.append($('<th>').text('Connect date'));
                        bncHeadRow.append($('<th colspan="2">').text('Client ID'));
                        bncHeadRow.append($('<th>').text('Connection'));
                        table.append(bncHeadRow);
                        _.each(_.sortBy(response.bnc, 'start_time'), function (stream) {
                            var streamRow = $('<tr class="settingsAccountSessions_stream_row">');
                            streamRow.append($('<td class="settingsAccountSessions_stream_start">').text(
                                new Date(stream.start_time * 1000).toString('ddd dd MMM yyyy HH:mm')
                            ));
                            streamRow.append($('<td colspan="2" class="settingsAccountSessions_stream_client_id">').text(stream.client_id));
                            var connection = this.model.connections.get(stream.cid);
                            streamRow.append($('<td class="settingsAccountSessions_stream_connection">').html(
                                this.formatter.linkModel(connection, {
                                    className: 'server'
                                })
                            ));
                            table.append(streamRow);
                        }, this);
                    }
                    this.$('.settingsAccountSessions_sessions').html(table);
                    table.find('.settingsAccountSessions_stream_age span').timeago();
                }
            }, this));
        }
        this.$('.settingsContents').removeClass('settingsContents--show');
        this.$('.settingsMenu__item').removeClass('settingsMenu__item--selected');
        this.$('.settingsContents__' + section).addClass('settingsContents--show');
        this.$('.settingsMenu__item__' + section).addClass('settingsMenu__item--selected');
    },
    hide: function (options) {
        options = options || {};
        if (this.isSelected()) {
            this.selected = false;
            this.$el.removeClass('settingsContainer--show');
            
            if (!options.silent && !this.model.selectPreviousBuffer()) {
                this.model.trigger('currentBufferChange', this);
            }
            
            this.reset();
            
            this.hideError();
            this.$el.removeSpin();
            this.accountFormErrors.hide();
            this.accountFormSuccesses.hide();
            this.passwords.prop('disabled', true);
        }
    },
    resetPasswords: function () {
        this.settingsCurrentPasswords.val('');
        this.settingsNewPassword.val('');
    },
    // This will get called from MainAreaView
    renderOverlay: function (overlay) {
        this.overlay.append(overlay);
        
        return this;
    },
    generateSidebar: function () {
        var menu = $('<div class="settingsMenu">');
        this.$('.settingsContents').each(_.bind(function (i, contents) {
            var section = $(contents).data('section');
            $(contents).addClass('settingsContents__' + section);
            var title = $(contents).find('.settingsTitle').text();
            var link = $('<a class="settingsMenu__link">').attr('href', '/?/settings=' + section).text(title);
            menu.append($('<div class="settingsMenu__item">').addClass('settingsMenu__item__' + section).append(link));
        }, this));
        this.$el.prepend(menu);
    },
    hideAccountForms: function () {
        this.$('.settingsAccountForm').removeClass('settingsAccountForm--show');
    },
    generateAccountLinks: function () {
        this.$('.settingsAccountForm').each(_.bind(function (i, form) {
            var action = $(form).data('action');
            $(form).addClass('settingsAccountForm__' + action);
            var title = $(form).find('.settingsAccountFormTitle').text();
            var button = $('<button type="button" class="link settingsAccountLinks__link">').text(title);
            button.click(_.bind(function (e) {
                this.hideAccountForms();
                $(form).addClass('settingsAccountForm--show');
            }, this));
            this.$('.settingsAccountLinks').append($('<p class="settingsAccountLinks__item">').addClass('settingsAccountLinks__item__' + action).append(button));
        }, this));
    },
    render: function () {
        this.generateSidebar();
        this.generateAccountLinks();
        this.$el.append(this.overlay.render().el);
    },
    reset: function () {
        this.renderStat();
        this.renderName();
        this.renderEmail();
        this.renderHighlights();
        this.renderAutoaway();
        this.renderPrefs();
        this.resetPasswords();
    },
    renderAvatar: function () {
        var avatarLink = Avatar.redirectTemplate(this.model.id, '');
        $('#settingsAvatarLink').attr('href', avatarLink).text(avatarLink);
    },
    init: function () {
        this.generateMessageLayoutPreview();
        this.renderAvatar();
        this.renderFeatures();
        this.renderUpgradeableSlackConnections();
        this.reset();
        this.renderEnableNotifications();
        this.bindSessionEvents();
        _.extend(this.events, {
            'click .settings__embedExternal': 'embedExternalClick',
            'click .settings__embedMastodon': 'embedMastodonClick',
            'change .userPrefsCheckbox': 'saveUserPrefs',
            'change .labsCheckbox': 'saveLabs',
            'change #settingsAutoaway': 'autoawayChange',
            'input .settings__inputSetting': 'inputSettingChange'
        });
        this.delegateEvents();
    },
    bindSessionEvents: function () {
        this.model.bind('stat', this.renderStat, this);
        this.model.bind('prefChange', this.renderPrefs, this);
        this.model.bind('featureChange', this.renderFeatures, this);
        this.listenTo(this.model.connections, 'change', this.renderUpgradeableSlackConnections);
    },
    renderStat: function () {
        this.$('.settings__upgradeRequired').toggle(!this.model.isUnlimited());
    },
    inputSettingChange: function (e) {
        this.debouncedSave();
    },
    autoawayChange: function (e) {
        this.save();
    },
    save: function (callback) {
        this.hideError();
        this.closeButton.addSpin();
        this.model.userSettings(this.name.val(), this.highlights.val(), this.autoaway.is(":checked"), _.bind(function (response) {
            this.closeButton.removeSpin();
            if (!response.success) {
                var message;
                switch (response.message) {
                case 'realname':
                    message = 'Invalid real name';
                    break;
                case 'hwords':
                    message = 'Error setting highlights';
                    break;
                case 'autoaway':
                    message = 'Error setting auto-away';
                    break;
                default:
                    message = 'Error updating account settings: ' + response.message;
                    break;
                }
                this.showError(message);
            }
        }, this));
    },
    submitForm: function (e) {
        e.preventDefault();
        this.save();
    },
    checkboxEnabled: function (checkbox) {
        return true;
    },
    embedExternalClick: function (e) {
        var checkbox = $(e.target);
        if (this.checkboxEnabled(checkbox)) {
            var checked = checkbox.prop('checked');
            if (checked && !this.model.getPref('inlineimagewarn')) {
                this.model.trigger('inlineImageConfirm', _.bind(function () {
                    checkbox.prop('checked', checked);
                    this.saveUserPrefs();
                }, this));
                checkbox.prop('checked', !checked);
                return false;
            }
        }
    },
    embedMastodonClick: function (e) {
        var checkbox = $(e.target);
        if (this.checkboxEnabled(checkbox)) {
            var checked = checkbox.prop('checked');
            if (checked && !this.model.getPref('inlinemastodonwarn')) {
                this.model.trigger('inlineMastodonConfirm', _.bind(function () {
                    checkbox.prop('checked', checked);
                    this.saveUserPrefs();
                }, this));
                checkbox.prop('checked', !checked);
                return false;
            }
        }
    },
    saveCheckboxes: function (checkboxes) {
        var values = {};
        var checks = checkboxes.toArray();
        _.each(checks, function (checkbox, i) {
            checkbox = $(checkbox);
            if (!(checkbox.attr('name') in values) && this.checkboxEnabled(checkbox)) {
                var value = !!checkbox.prop('checked');
                if (checkbox.hasClass('inverse')) {
                    value = !value;
                }
                values[checkbox.attr('name')] = value;
            }
        }, this);
        return values;
    },
    saveUserPrefs: function () {
        var prefs = this.saveCheckboxes(this.userPrefsCheckboxes);
        this.model.setPref(prefs);
    },
    saveLabs: function () {
        var labs = this.saveCheckboxes(this.labsCheckboxes);
        this.model.setLabs(labs);
    },
    changeCredentials: function (form, oldpassword, newpassword, email) {
        form.addSpin();
        form.find('.userSuccess').hide();
        form.find('.userError').hide();
        this.model.changeCredentials(
            oldpassword,
            newpassword,
            email,
            _.bind(function (response) {
                form.removeSpin();
                this.resetPasswords();
                if (response.success) {
                    form.find('.userSuccess').show();
                } else {
                    var message;
                    switch (response.message) {
                    case 'oldpassword':
                        message = 'Current password incorrect';
                        break;
                    case 'rate_limited':
                        message = 'Rate limited, try again in a few mins';
                        break;
                    case 'newpassword':
                        message = 'Invalid new password';
                        break;
                    case "password_too_long":
                        message = 'Maximum password length: ' + window.IRCConfig.max_password_length;
                        break;
                    case 'password_error':
                        message = 'Invalid password, try again';
                        break;
                    case 'email_invalid':
                        message = 'Invalid email address';
                        break;
                    case 'email_not_unique':
                        message = 'This email address is already in use';
                        break;
                    default:
                        message = 'Error changing password: ' + response.message;
                        break;
                    }
                    form.find('.userError').hide().text(message).fadeIn('fast');
                }
            }, this)
        );
    },
    submitEmailForm: function (e) {
        e.preventDefault();

        var form = $(e.target);
        var data = form.serializeForm();
        this.changeCredentials(
            form,
            data.oldpassword,
            '',
            data.email
        );
    },
    submitPasswordForm: function (e) {
        e.preventDefault();

        var form = $(e.target);
        var data = form.serializeForm();
        this.changeCredentials(
            form,
            data.oldpassword,
            data.password,
            this.model.get('email')
        );
    },
    submitDeleteForm: function (e) {
        e.preventDefault();
        if (!confirm('Are you sure you want to delete your account?')) {
            return;
        }
        var form = $(e.target);
        var data = form.serializeForm();
        form.addSpin();
        form.find('.userError').hide();
        this.model.deleteAccount(data.password, _.bind(function (response) {
            form.removeSpin();
            if (response.success) {
                this.hide();
            } else {
                var message;
                switch (response.message) {
                case 'bad_pass':
                    message = 'Incorrect password, try again';
                    break;
                case 'last_admin_cant_leave':
                    message = 'You can’t delete your account as the last admin of a team. <a href="/?/teams">Transfer ownership</a> before continuing';
                    break;
                default:
                    message = 'Error deleting account: ' + this.formatter.escapeText(response.message);
                }
                form.find('.userError').hide().html(message).fadeIn('fast');
            }
        }, this));
    },
    clickExportLogs: function (e) {
        e.preventDefault();
        this.model.trigger('exportConfirm');
    },
    clickEnableNotifications: function (e) {
        e.preventDefault();
        this.renderEnableNotifications();
        IRCCloudNotifier.requestPermission(_.bind(function (permission) {
            if (permission === 'granted') {
                this.model.trigger('notify', null, {
                    tag: 'test',
                    title: 'Sample notification',
                    body: 'You’ll now get a notification whenever you’re highlighted',
                    click: _.bind(function (notification) {
                        notification.close();
                    }, this)
                });
            }
            this.renderEnableNotifications();
        }, this));
    },
    testAlertSound: function (e) {
        e.preventDefault();
        this.model.trigger('playAlert', true);
    },
    renderEnableNotifications: function () {
        this.enableNotifications.toggle(IRCCloudNotifier.shouldRequest());
        return this;
    },
    renderName: function () {
        this.name.val(this.model.get('name'));
        return this;
    },
    renderEmail: function () {
        this.email.val(this.model.get('email'));
        return this;
    },
    renderHighlights: function () {
        this.highlights.val(this.model.getHighlights().join(' '));
        return this;
    },
    renderAutoaway: function () {
        this.autoaway.prop('checked', this.model.get('autoaway'));
        return this;
    },
    chooseSidebarLayout: function (e) {
        var left = $(e.currentTarget).is('.sidebarChooser__left');
        this.model.setPref('layout-left', left);
    },
    chooseTheme: function (e) {
        var theme = $(e.currentTarget).data('theme');
        if (this.model.getPref('theme-auto') && theme == 'dawn') {
            return;
        }
        this.model.setPref('theme', theme);
    },
    chooseFont: function (e) {
        var font = $(e.target).data('font');
        this.model.setPref('font', font);
    },
    generateMessageLayoutPreview: function () {
        var nick = this.model.getNick();
        this.messageLayoutPreviewBuffer = new Channel({
            cid: 1
        }, {
            session: this.model,
            connection: new Connection({
                cid: 1,
                bid: 1,
                nick: nick,
                hostname: 'irc.irccloud.com',
                port: 6697,
                ssl: true
            }, {
                session: this.model
            })
        });
        var nowHour = new Date().getHours();
        var timeOfDay;
        if (nowHour < 5) {
            timeOfDay = 'time of night';
        } else if (nowHour < 12) {
            timeOfDay = 'morning';
        } else if (nowHour < 18) {
            timeOfDay = 'afternoon';
        } else {
            timeOfDay = 'evening';
        }
        var nowTs = this.model.backend.ts();
        var mentions0 = {};
        mentions0[nick] = [[3, nick.length]];
        var messageData = [{
            eid: (nowTs-10000)*1000,
            bid: 1,
            cid: 1,
            type: 'buffer_msg',
            from: 'amita',
            from_realname: 'Amita Ramanujan',
            avatar_url: this.model.getOrigin() + '/static/numb3rs/amita-{size}.png',
            from_mode: 'o',
            msg: 'Hi ' + nick + '! 🙋🏽‍♀️',
            self: false,
            highlight: true,
            entities: {
                mentions: mentions0
            }
        }, {
            eid: (nowTs-7000)*1000,
            bid: 1,
            cid: 1,
            type: 'buffer_me_msg',
            from: 'don',
            from_realname: 'Don Eppes',
            avatar_url: this.model.getOrigin() + '/static/numb3rs/don-{size}.png',
            msg: 'waves',
            self: false
        }, {
            eid: (nowTs-5000)*1000,
            bid: 1,
            cid: 1,
            type: 'buffer_msg',
            from: nick,
            from_realname: this.model.get('name'),
            avatar: this.model.get('avatar'),
            msg: ':wave:',
            self: true
        }, {
            eid: (nowTs-2000)*1000,
            bid: 1,
            cid: 1,
            type: 'buffer_msg',
            from: nick,
            from_realname: this.model.get('name'),
            avatar: this.model.get('avatar'),
            msg: 'Hey @amita, @don. How’s everyone this ' + timeOfDay + '?',
            self: true,
            entities: {
                mentions: {
                    amita: [[5, 5]],
                    don: [[13,3]]
                }
            }
        }, {
            eid: nowTs*1000,
            bid: 1,
            cid: 1,
            type: 'buffer_msg',
            from: 'charlie',
            from_realname: 'Charlie Eppes',
            avatar_url: this.model.getOrigin() + '/static/numb3rs/charlie-{size}.png',
            from_mode: 'v',
            msg: 'Not too bad :)',
            self: false
        }];
        var messages = [];
        _.each(messageData, function (data) {
            var m = new Message(data, {
                buffer: this.messageLayoutPreviewBuffer
            });
            m._previousMessage = _.last(messages);
            messages.push(m);
        }, this);
        var renderer = new LineMessageRenderer(this.messageLayoutPreviewBuffer);
        renderer.firstRender = true;
        var rows = renderer.renderMessages(messages).flush();
        var viewport = $('<div class="viewport">');
        var log = $('<div class="log">');
        log.append(rows);
        viewport.append(log);
        this.messageLayoutPreview.append(viewport);
    },
    toggleCheckboxEnabled: function (checkbox, enabled, forceCheck) {
        if (enabled) {
            checkbox
                .prop('disabled', false)
                .closest('tr')
                .removeClass('messageLayout--disabled');
        } else {
            checkbox
                .prop('disabled', true)
                .closest('tr')
                .addClass('messageLayout--disabled');
        }
        if (forceCheck) {
            checkbox.prop('checked', true);
        }
    },
    renderMessageLayoutPreview: function (e) {
        var multiLine = this.messageLayoutPreviewBuffer.multiline();
        var avatars = this.messageLayoutPreviewBuffer.avatarsEnabled();
        var imageAvatars = this.messageLayoutPreviewBuffer.imageAvatarsEnabled();
        var externalAvatars = this.messageLayoutPreviewBuffer.embedExternalAvatars();
        var timeRightChangeAllowed = !(avatars && multiLine);
        this.toggleCheckboxEnabled(
            this.$('#prefsImageAvatars'),
            avatars
        );
        this.toggleCheckboxEnabled(
            this.$('#prefsRealname'),
            multiLine
        );
        this.toggleCheckboxEnabled(
            this.$('#prefsTimestampRight'),
            timeRightChangeAllowed,
            !timeRightChangeAllowed
        );
        var timeRight = this.messageLayoutPreviewBuffer.isTimeRight();
        var realnames = this.messageLayoutPreviewBuffer.showRealnames();
        
        this.messageLayoutPreview.toggleClass('multiline', multiLine);
        this.messageLayoutPreview.toggleClass('oneline', !multiLine);
        this.messageLayoutPreview.toggleClass('realnames-on', realnames);
        this.messageLayoutPreview.toggleClass('realnames-off', !realnames);
        this.messageLayoutPreview.toggleClass('time-right', timeRight);
        this.messageLayoutPreview.toggleClass('time-left', !timeRight);
        this.messageLayoutPreview.toggleClass('avatars-on', avatars);
        this.messageLayoutPreview.toggleClass('avatars-off', !avatars);
        this.messageLayoutPreview.toggleClass('avatars-image-on', imageAvatars);
        this.messageLayoutPreview.toggleClass('avatars-image-off', !imageAvatars);
        this.messageLayoutPreview.toggleClass('avatars-external', externalAvatars);
        this.messageLayoutPreview.toggleClass('avatars-noexternal', !externalAvatars);
    },
    renderFeatures: function () {
        
    },
    renderUpgradeableSlackConnections: function () {
        $('#upgradeableSlackConnections .networks').empty();
        var showHint = false;
        this.model.connections.each(function (conn) {
            if (conn.isSlackUpgradable()) {
                showHint = true;
                var row = $('<div class="upgradeSlack network">');

                var hostLine = $('<p class="head">');
                hostLine.append('<i class="fa fa-slack">');
                var displayName = conn.getDisplayName();
                hostLine.append($('<span class="host">').text(' ' + displayName + ' '));
                var hostname = conn.getHostname();
                if (hostname != displayName) {
                    hostLine.append(' / ');
                    hostLine.append(this.formatter.escapeText(hostname));
                }
                row.append(hostLine);

                var detailLine = $('<div class="details">');
                detailLine.text('Nick: ' + conn.getNick());

                row.append(detailLine);

                row.on('click', _.bind(function (e) {
                    if (conn.isSlackUpgradable()) {
                        startSlackAuth(this.model, {
                            data: {
                                cid: conn.id
                            },
                            onSuccess: _.bind(function (response) {
                                this.model.setFocusOnMakeServer(response.cid);
                            }, this),
                            onError: _.bind(function (message) {
                                if (message) {
                                    conn.trigger('postError', {
                                        message: message
                                    });
                                }
                            }, this)
                        });
                    }
                }, this));

                $('#upgradeableSlackConnections .networks').append(row);
            }
        }, this);
        this.$('.settings__labsSlack_upgradeable').toggle(showHint);
    },
    renderPrefs: function () {
        var left = !!this.model.getPref('layout-left');
        this.$('.sidebarChooser__left').toggleClass('sidebarChooser--selected', left);
        this.$('.sidebarChooser__right').toggleClass('sidebarChooser--selected', !left);
        
        var theme = this.model.getTheme();
        this.$('.themeChooser').removeClass('themeChooser--selected');
        if (this.model.getPref('theme-auto')) {
            this.$('.themeChooser').addClass('themeChooser--auto');
            var darkTheme = this.model.getDefaultDarkTheme();
            this.$('.themeChooser__' + darkTheme).addClass('themeChooser--selected');
            this.$('.themeChooser__dawn').addClass('themeChooser--selected');
        } else {
            this.$('.themeChooser__' + theme).addClass('themeChooser--selected');
        }
        
        var font = this.model.getFont();
        this.$('.fontChooser__button').removeClass('active');
        this.$('.fontChooser__' + font).addClass('active');
        
        this.renderCheckboxes(this.userPrefsCheckboxes, _.bind(function (name) {
            return !!this.model.getPref(name);
        }, this));
        this.renderCheckboxes(this.labsCheckboxes, _.bind(function (name) {
            return this.model.labCheck(name);
        }, this));
        this.renderMessageLayoutPreview();
        return this;
    },
    renderCheckboxes: function (checkboxes, valueFun) {
        checkboxes.each(_.bind(function (i, checkbox) {
            checkbox = $(checkbox);
            if (this.checkboxEnabled(checkbox)) {
                var value = valueFun(checkbox.attr('name'));
                if (checkbox.hasClass('inverse')) {
                    value = !value;
                }
                checkbox.prop('checked', value);
            }
        }, this));
    },
    hideError: function () {
        this.error.hide();
    },
    showError: function (message) {
        this.error.hide().text(message).fadeIn('fast');
    }
});


module.exports = SettingsView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/settingsview.js
// module id = ZAC8
// module chunks = 1